/**
 * ป้าย version มุมล่าง sidebar (owner/HR/หัวหน้า) — คลิกเปิดประวัติการอัปเดตระบบ.
 */
import { useState } from 'react';
import { Sparkles, X } from 'lucide-react';
import { CHANGELOG, APP_VERSION, LAST_UPDATED } from '../lib/changelog';

export function ChangelogBadge() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="w-full mt-2 px-2 py-1 text-[10px] text-[#9a938c] hover:text-[#c14a8c] transition flex items-center gap-1"
        title="ดูประวัติการอัปเดตระบบ"
      >
        <Sparkles className="w-3 h-3 shrink-0" />
        <span className="truncate">v{APP_VERSION} · อัปเดต {LAST_UPDATED}</span>
      </button>

      {open && (
        <div className="fixed inset-0 bg-black/40 z-[60] flex items-end lg:items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div className="bg-white w-full max-w-md rounded-2xl p-5 max-h-[80vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h2 className="font-semibold flex items-center gap-1.5 text-[#2a2226]">
                <Sparkles className="w-4 h-4 text-[#c14a8c]" /> ประวัติการอัปเดตระบบ
              </h2>
              <button onClick={() => setOpen(false)} aria-label="ปิด"><X className="w-5 h-5 text-gray-400" /></button>
            </div>
            <div className="space-y-4">
              {CHANGELOG.map((e) => (
                <div key={e.version} className="border-l-2 border-[#F0BCDF] pl-3">
                  <div className="flex items-baseline gap-2 flex-wrap">
                    <span className="text-sm font-bold text-[#2a2226]">v{e.version}</span>
                    <span className="text-xs text-gray-400">{e.date} · {e.time} น.</span>
                  </div>
                  <ul className="mt-1.5 space-y-1">
                    {e.items.map((it, i) => (
                      <li key={i} className="text-[13px] text-gray-700 flex gap-1.5">
                        <span className="text-[#c14a8c] shrink-0">•</span><span>{it}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
